export default {
  name: 'embed',
  type: 'layout',
  isRequired: true,
  essential: false
}
